import { Route, Routes } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { DisclaimerGate } from '../components/DisclaimerGate';
import { DashboardPage } from '../pages/DashboardPage';
import { HistoryPage } from '../pages/HistoryPage';
import { MethodologyPage } from '../pages/MethodologyPage';
import { SettingsPage } from '../pages/SettingsPage';
import { TermsPage } from '../pages/TermsPage';
import { PrivacyPage } from '../pages/PrivacyPage';
import { SupportPage } from '../pages/SupportPage';
import { Btc15PredictorPage } from '../pages/Btc15PredictorPage';
import { FightMarketPage } from '../pages/FightMarketPage';
import { CrashBouncePage } from '../pages/CrashBouncePage';
import { MarketMakerPage } from '../pages/MarketMakerPage';
import { LiquidityRewardsPage } from '../pages/LiquidityRewardsPage';
import { MartingalePage } from '../pages/MartingalePage';
import { BreakoutWatchPage } from '../pages/BreakoutWatchPage';
import { ListingRadarPage } from '../pages/ListingRadarPage';
import { RugCheckPage } from '../pages/RugCheckPage';
import { PaperTestsPage } from '../pages/PaperTestsPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { usePredictorWarmup } from '../hooks/useBtc15Predictor';

export function App() {
  usePredictorWarmup();
  return (
    <>
      <DisclaimerGate />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<DashboardPage />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="btc-15m-predictor" element={<Btc15PredictorPage />} />
          <Route path="fight-market" element={<FightMarketPage />} />
          <Route path="paper-tests" element={<PaperTestsPage />} />
          <Route path="crash-bounce" element={<CrashBouncePage />} />
          <Route path="market-maker" element={<MarketMakerPage />} />
          <Route path="liquidity-rewards" element={<LiquidityRewardsPage />} />
          <Route path="martingale" element={<MartingalePage />} />
          <Route path="breakout-watch" element={<BreakoutWatchPage />} />
          <Route path="listing-radar" element={<ListingRadarPage />} />
          <Route path="rug-check" element={<RugCheckPage />} />
          <Route path="methodology" element={<MethodologyPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="support" element={<SupportPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
